module.exports = __webpack_public_path__ + "static/media/about02.0b4e9372.png";